import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import { topicTeacherImgs } from '../../images/topicImg'

export class StyleOneClassTables extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { Data, onMeiQiaCustomer, listId } = this.props;
    return (
      <div className="topic-style-one-class-tables">
        <div className='class_content_tips_box'>
          <div className='class_info_box flex_row'>
            <div className='class_content_title'>班级介绍</div>
            <div className='class_content_info'>{Data.classInfo}</div>
          </div>
          <div className='class_info_box flex_row'>
            <div className='class_content_title'>配套服务</div>
            <div className='class_content_info assort_service flex_row'>
              {Data.assortService && Data.assortService.map(item => <div className='service_items flex_row' key={item.id}>
                <img src={topicTeacherImgs.class_yes} alt="" />
                <div className='sevice_items_title'>{item.title}</div>
              </div>)}
            </div>
          </div>
          <div className='class_info_box flex_row'>
            <div className='class_content_title letter_space_3'>有效期</div>
            <div className='class_content_info'>{Data.validity}</div>
          </div>
        </div>

        <div className='class_info_tables'>
          <div className='info_tables_tr flex_row'>
            <div className='info_tables_th flex_row width460'>课程名称</div>
            <div className='info_tables_th flex_row width110'>精讲名师</div>
            <div className='info_tables_th flex_row width100'>课时</div>
            <div className='info_tables_th flex_row width120'>价格</div>
            <div className='info_tables_th flex_row width160'>免费体验</div>
            <div className='info_tables_th flex_row width124'>报名</div>
          </div>
          {Data.courseList && Data.courseList.map(item => <div className='info_tables_td_tr flex_row' key={item.id}>
            <div className='info_tables_td flex_row width460 title'>{item.title}</div>
            <div className='info_tables_td flex_row width110'>{item.teacher}</div>
            <div className='info_tables_td flex_row width100'>{item.classHour}</div>
            <div className='info_tables_td flex_row width120 price'>{item.price}</div>
            <div className='info_tables_td flex_row width160 price'>{item.experience}<img style={{ marginLeft: '8px' }} src={item.icon} alt="" /></div>
            <div className='info_tables_td flex_row width124'>
              <div className='apply_btn flex_row' onClick={onMeiQiaCustomer}>报名</div>
            </div>
          </div>)}
          {/* 中学的教材精讲班展示 */}
          {listId === 3 && Data.id === 1 && <div className='info_tables_td_tr flex_row' style={{ cursor: 'pointer' }} onClick={onMeiQiaCustomer}>
            更多课程请详细咨询客服>>
          </div>}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleOneClassTables);



// WEBPACK FOOTER //
// ./src/features/style-one/StyleOneClassTables.js